import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import reportWebVitals from './reportWebVitals';

// Import CSS files - order matters!
import './globals.css'; // ShadCN/Tailwind styles must come first
import './index.css'; // Additional styles come after

try {
  const rootElement = document.getElementById('root');
  
  if (rootElement) {
    const root = ReactDOM.createRoot(rootElement as HTMLElement);
    
    root.render(
      <React.StrictMode>
        <App />
      </React.StrictMode>
    );
  } else {
    console.error('Root element not found in the DOM');
  }
} catch (error) {
  console.error('Error initializing React app:', error);
}

reportWebVitals();
